import {FactoryProvider, NgModule} from '@angular/core';
import {HostService} from '@app/core/global/host.service';
import {WINDOW} from '@app/core/global/global.const';

const windowProvider: FactoryProvider = {
    provide: WINDOW,
    useFactory: () => window
};
export const WINDOW_PROVIDERS = [
    windowProvider
];

@NgModule({
    declarations: [

    ],
    imports: [

    ],
    exports: [

    ],
    providers: [
        WINDOW_PROVIDERS,
        HostService
    ]
})
export class GlobalModule { }
